import PropTypes from 'prop-types'
import React from 'react'
import Grid from '../../Grid'
import config from 'Config'

const CardLoadingGrid = props => {
  return (
    <div className="product-list-wrapper">
      <Grid pageName={props.pageName} className="product-list-load">
        {Array(config.loading[props.pageName])
          .fill(0)
          .map((num, index) => {
            return <div key={index} className="product-list-loading" />
          })}
      </Grid>
    </div>
  )
}

CardLoadingGrid.propTypes = {
  pageName: PropTypes.any
}

export default CardLoadingGrid
